<template>
    <v-dialog width="1200" v-model="dialog">
        <v-card>
            <v-card-title class="secondary white--text">
                <span>Vehicle List</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon class="white--text">mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pt-2">
                <!-- Smaller Search Box -->
                <v-text-field v-model="quickFilterText" label="Search" outlined dense hide-details
                    style="max-width: 300px; font-size: 13px;" />

                <!-- Vehicle Table -->
                <div class="ag-theme-alpine mt-4" >
                    <ag-grid-vue class="ag-theme-alpine" :columnDefs="columnDefs" :rowData="vehicleList"
                        :defaultColDef="defaultColDef" :quickFilterText="quickFilterText" rowSelection="single"
                        domLayout="autoHeight" />
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

export default {
    components: {
        AgGridVue,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        vehicleList: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    data() {
        return {
            quickFilterText: "",
            columnDefs: [
                { headerName: "Fleet Number", field: "inventory_number", sortable: true, filter: true },
                { headerName: "Status", field: "status", sortable: true, filter: true },
                { headerName: "Vehicle Type", field: "vehicle_type", sortable: true, filter: true },
                { headerName: "Driver Name", field: "driver_name", sortable: true, filter: true },
                { headerName: "Trip", field: "trip_data.trip_number", sortable: true, filter: true },
                { headerName: "Next Availability", field: "next_availability_date", sortable: true, filter: true },
            ],
            defaultColDef: {
                resizable: true,
                flex: 1,
            },
        };
    },
};
</script>
